import { FC } from 'react';
import { useLocale } from '@components/Contexts/LocaleContext';
import { consentText } from './consent';

interface Props {
  onChangePreference: () => void;
  onAcceptAll: () => void;
}

// Same look as the old cdm.pdpa-codium.com banner: a card pinned near the
// bottom, text on top, "Change Preferences" and "Accept All" bottom-right.
const CookieBanner: FC<Props> = ({ onChangePreference, onAcceptAll }) => {
  const { lang } = useLocale();
  const text = consentText[lang];

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={text.title}
      className="fixed bottom-[5%] left-0 z-[999999] w-full box-border px-5"
    >
      <section className="mx-auto max-w-[900px] rounded-lg border border-[#e8e8e8] bg-white p-2.5 text-sm text-black shadow-[0_2px_8px_0_rgba(0,0,0,0.05)]">
        <div className="flex min-h-[100px] flex-col p-4">
          <p>
            <strong>{text.title}</strong>
            <br />
            {text.content}{' '}
            <a
              href="/cookie-policy"
              target="_blank"
              rel="noreferrer"
              className="cursor-pointer text-[blue] underline"
            >
              {text.policy}
            </a>
          </p>
        </div>
        <div className="flex items-center justify-end px-4 pb-4">
          <button
            type="button"
            onClick={onChangePreference}
            className="mx-[2%] cursor-pointer text-[blue] underline"
          >
            {text.changePreference}
          </button>
          <button
            type="button"
            onClick={onAcceptAll}
            className="inline-flex h-[35px] w-[15%] min-w-[108px] items-center justify-center whitespace-pre rounded-md bg-[#09071f] px-4 font-semibold text-white transition-colors"
          >
            {text.acceptAll}
          </button>
        </div>
      </section>
    </div>
  );
};

export default CookieBanner;
